document.addEventListener("DOMContentLoaded", function () {
  let isLoading = false;
  let requestQueue = [];
  let scrollHandlerActive = true; // track karega handler active hai ya nahi

  var infiniteScroll = new Ajaxinate({
    container: '#CollectionLoop',
    pagination: '#CollectionPagination',
    method: 'scroll',
    offset: 0,
    loadingText: 'Loading...',
    callback: function () {
      var loader = document.querySelector('#CollectionPagination .loading-overlay__spinner');
      if (loader) loader.style.display = "none";

      isLoading = false;
      requestQueue.shift(); // request complete hone ke baad remove karo queue se

      // 👇 1st run complete hone ke baad scroll handler disable kar do
      scrollHandlerActive = false;
    }
  });

  var originalLoadMore = infiniteScroll.loadMore;
  infiniteScroll.loadMore = function () {
    if (isLoading || requestQueue.length > 0) {
      console.log('Request blocked - already loading or in queue');
      return;
    }

    isLoading = true;
    requestQueue.push(Date.now());

    infiniteScroll.removeScrollListener();

    var loader = document.querySelector('#CollectionPagination .loading-overlay__spinner');
    if (loader) loader.style.display = "inline-block";

    originalLoadMore.call(this);
  };

  // Debounced scroll handler
  let scrollTimer;
  document.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      if (!scrollHandlerActive) {
        // 👇 agar pehla run ho gaya hai, to wait until user phir se end per aaye
        if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 50)) {
          console.log("Scroll handler re-activated");
          scrollHandlerActive = true; // dobara activate
        }
        return;
      }

      if (!isLoading && requestQueue.length === 0) {
        if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 300)) {
          infiniteScroll.loadMore();
        }
      }
    }, 150);
  });
});